import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Globals } from 'app/services/globals'
import { Tag } from 'app/models/tag';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class TagService {
    constructor(private http: HttpClient, private globals: Globals, private formBuilder: FormBuilder,
            private userService: UserService) { 
        this.userService.currentUser.subscribe(user => {
            if (user && this.globals.api_base_url) {
                this.getAll().subscribe();
            }
        });
    }

    currentTagsSubject: BehaviorSubject<Tag[]> = new BehaviorSubject<Tag[]>([]);

    // Use subscription on currentTagsSubject instead
    private getAll() {
        return this.http.get<Tag[]>(`${this.globals.api_base_url}/tags`, {}).pipe(tap((t) => {
            this.currentTagsSubject.next(t);
        }));
    }

    add(tagName: string) {
        return this.http.post<Tag>(`${this.globals.api_base_url}/tag`, {name: tagName}).pipe(finalize(()=> {
            this.getAll().subscribe();  // update the subject
        }));
    }

    canAddTags() : boolean {
        return this.userService.can('super.admin.misc.tags.create');
    }

    // Returns a FormGroup object mapping with the contact's fields with validators sent
    formGroup(){
        return this.formBuilder.group({
            id: [undefined],
            name: ['', [Validators.required, Validators.maxLength(128)]]
        });
    }
}